import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import { browserHistory } from 'react-router'

import Survey from 'app/Components/Survey'
import Question1 from './questions/Question1'

import Controller from 'app/Components/FormsController'

export default class SurveyPage extends Component {
  state =
    {
      current: Question1,
      previous: [],
      answers: {},
    }

  @autobind change(component) {
    let previous = this.state.previous
    previous.push(this.state.current)
    let current = component
    this.setState({ current, previous })
  }

  @autobind goBack(event) {
    if (!this.state.previous.length) {
      browserHistory.push('/')
    } else {
      let previous = this.state.previous
      let current = previous.pop()
      this.setState({ previous, current })
    }
  }

  @autobind pushAnswer(answer, title, question) {
    Controller.update(title, { question, answer })
  }

  get answers() {
    return this.state.answers
  }

  render() {
    const Comp = this.state.current
    return (
      <div>
        <Survey>
          <Comp {...this.props} {...this.refs} change={this.change} goBack={this.goBack} pushAnswer={this.pushAnswer} anwsers={this.answers} />
        </Survey>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./survey/index.js
 **/